module.exports = __webpack_public_path__ + "static/media/mortgage_insurance.2f5fa9fd.svg";